var exports = {
  "i": "xf61da738--d495b9--favorite-button",
  "v": "xf61da738--d495b9--active",
};

module.exports = exports;
